// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/style/comon.css
// module id = 2414
// module chunks = 191